<div class="deliverable-container">
    <div>{{deliverable.description}}</div>
</div>